import React from 'react';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { StyledSelectInput } from '../StyledSelectInput';

export const Radius = () => {
  const {
    modelPrefix,
    onBlur,
    zipRadiusTypes,
    radiusTypeFlag,
    typesSubText,
    typesErrorPlaceholder,
  } = usePropsContext();

  return (
    <StyledSelectInput
      labelKey="referenceDesc"
      valueKey="referenceCode"
      width="50%"
      data-testid="radius"
      placeholder={radiusTypeFlag.isError ? typesErrorPlaceholder : ''}
      subText={radiusTypeFlag.isError ? typesSubText : ''}
      label="Radius within (miles)"
      model={`${modelPrefix}.zipRadius`}
      validators={{
        // Only display 'Please select a value' when there isn't an error
        required: radiusTypeFlag.isError ? '(!)' : 'Please select a value',
      }}
      options={zipRadiusTypes}
      isError={radiusTypeFlag.isError}
      enableOutsideScroll
      onBlur={() => onBlur(`${modelPrefix}.zipRadius`)}
    />
  );
};
